/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  InputHeader,
  StyledInput,
  Icon,
  Input,
  Validation,
} from "./BorderTextArea.style";

const BorderTextArea = ({
  header,
  name,
  label,
  register,
  required,
  type,
  error,
  value,
  icon,
  onChange,
  validationLabel,
  readOnly,
  multiLine,
}) => {
  return (
    <Container>
      <InputHeader>{header}</InputHeader>
      <Input>
        <StyledInput
          name={name}
          label={label}
          placeholder={label}
          ref={register(required)}
          type={type}
          defaultValue={value}
          onChange={onChange}
          readOnly={readOnly}
          multiLine={multiLine}
        />
        {icon && <Icon>{icon}</Icon>}
      </Input>
      {!error && validationLabel && <Validation>*{validationLabel}</Validation>}
      <div>{error}</div>
    </Container>
  );
};

BorderTextArea.defaultProps = {
  header: "",
  label: PropTypes.string,
  required: {},
  type: "text",
  error: undefined,
  value: "",
  icon: undefined,
  onChange: undefined,
  validationLabel: "",
  readOnly: false,
  multiLine: false,
};

BorderTextArea.propTypes = {
  // input field header
  header: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  // react-hook-form validation object
  register: PropTypes.func.isRequired,
  required: PropTypes.object,
  type: PropTypes.string,
  // error object
  error: PropTypes.object,
  value: PropTypes.string,
  icon: PropTypes.element,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  multiLine: PropTypes.bool,
  // specify type of input expected below input field
  validationLabel: PropTypes.string,
};

export default BorderTextArea;
